import { render, staticRenderFns } from "./inPurchase.vue?vue&type=template&id=0605e6fc&scoped=true"
import script from "./inPurchase.vue?vue&type=script&lang=js"
export * from "./inPurchase.vue?vue&type=script&lang=js"
import style0 from "./inPurchase.vue?vue&type=style&index=0&id=0605e6fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0605e6fc",
  null
  
)

export default component.exports